import { DescriptionList } from "@prequel/shared-components";

import Timestamp from "@/components/Timestamp";
import { useDatasetContext } from "@/pages/import/DatasetsPage/DatasetPage";

const DatasetDetails = () => {
  const { dataset } = useDatasetContext();

  return (
    <>
      <div className="mt-6">
        <DescriptionList>
          <DescriptionList.Item label="ID" value={dataset.id} />
          <DescriptionList.Item label="Source ID" value={dataset.source_id} />
          <DescriptionList.Item label="Method" value={dataset.method} />
          {dataset.method === "table" && (
            <>
              <DescriptionList.Item label="Namespace" value={dataset.table.source_table_namespace} />
              <DescriptionList.Item label="Object Name" value={dataset.table.source_table_name} />
            </>
          )}
          <DescriptionList.Item label="Type" value={dataset.type} />
          <DescriptionList.Item label="Enabled" value={dataset.is_enabled ? "Yes" : "No"} />
          <DescriptionList.Item label="Frequency" value={`${dataset.frequency_minutes} min`} />
          <DescriptionList.Item label="Datalake Schema" value={dataset.datalake_schema} />
          <DescriptionList.Item label="Datalake Table" value={dataset.datalake_table_name} />
          <DescriptionList.Item label="Created" value={<Timestamp timestamp={dataset.created_at} />} />
          <DescriptionList.Item label="Updated" value={<Timestamp timestamp={dataset.updated_at} />} />
        </DescriptionList>
      </div>
    </>
  );
};

export default DatasetDetails;
